import Promise from 'promise';
import Axios from "axios";
import { axios, CommonHelper } from '../_helpers';

export const VideoService = {
    getVideoDetails,
    getThumbnailUrlAndDuration,
    createOrUpdateVideo,
    unallocatedVideos,
    getTopicVideos,
    getSubTopicVideos,
    importVideos,
    getAllVideos
};

function getVideoDetails(videoId) {
    return new Promise(function (resolve, reject) {
        axios.get('getVideoDetails?videoId='+videoId).then(async (res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};


function getThumbnailUrlAndDuration(embeddingUrl) {
    return new Promise(function (resolve, reject) {
        Axios.get(embeddingUrl).then((res) => {
                if (res.status===200) {
                    resolve(res.data);
                } else {
                    reject('Something went wrong.Please try after some time.');
                }
            }).catch(error => {
                reject('Wronge Embedding URL.');
            });
    })
};

function createOrUpdateVideo(video) {
    return new Promise(function (resolve, reject) {
        axios.post('updateVideoDetails', { ...video }).then((res) => {
                if (res.isSuccess) {
                    resolve(res);
                } else {
                    reject(res.message);
                }
            }).catch(error => {
                reject(error.message);
            });
    })
};

function unallocatedVideos() {
    return new Promise(function (resolve, reject) {
        axios.get('unallocatedVideos').then(async (res) => {
            if (res.isSuccess) {
                let { videos, thumbnailUrls,tags } = res.data;
                CommonHelper.setVideoInformation(videos, thumbnailUrls,tags).then(videosWithThumbnailUrls=>{
                    resolve(videosWithThumbnailUrls);
                });
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};

function getTopicVideos(TopicId) {
    let apiUrl = '';
    let user = JSON.parse(localStorage.getItem("user"));
    if(CommonHelper.hasRole(user, ['User'])){
        apiUrl = 'selectVideoForTopic?topicId=' + TopicId + '&userId='+  JSON.parse(localStorage.getItem('user')).custom_person_id
                + '&bookId='+  JSON.parse(localStorage.getItem('user')).bookId;
    }
    else {
        apiUrl = 'selectVideoForTopic?topicId=' + TopicId + '&userId='+  JSON.parse(localStorage.getItem('user')).custom_person_id
                + '&bookId=0';
    }
    return axios.get(apiUrl).then((response) => {
        return response.data;
    }).catch((error) => {
        return Promise.reject(error);
    });
};

function getSubTopicVideos(SubTopicId) {
    let apiUrl = '';
    let user = JSON.parse(localStorage.getItem("user"));
    if(CommonHelper.hasRole(user, ['User'])){
        apiUrl = 'selectVideoForSubTopic?subTopicId='+SubTopicId+'&userId='+JSON.parse(localStorage.getItem('user')).custom_person_id
        +'&bookId='+  JSON.parse(localStorage.getItem('user')).bookId;
    }
    else {
        apiUrl = 'selectVideoForSubTopic?subTopicId='+SubTopicId+'&userId='+JSON.parse(localStorage.getItem('user')).custom_person_id
        +'&bookId=0';
    }

    return axios.get(apiUrl).then((response) => {
        return response.data;
    }).catch((error) => {
        return Promise.reject(error);
    });
};

function importVideos(videos) {
    return new Promise(function (resolve, reject) {
        axios.post('importVideos', videos).then((res) => {
                if (res.isSuccess) {
                    resolve(res);
                } else {
                    reject(res.message);
                }
            }).catch(error => {
                reject(error.message);
            });
    })
};

function getAllVideos() {
    return new Promise(function (resolve, reject) {
        axios.get('getAllVideos').then(async (res) => {
            if (res.isSuccess) {
                resolve(res.data.videos);
            } else {
                reject(res.message);
            }
        }).catch(error => {
            reject(error.message);
        });
    })
};


// WEBPACK FOOTER //
// ./src/_services/video.service.js